/* globals grecaptcha, jQuery */
import "core-js/stable";
import "regenerator-runtime/runtime";
if(window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
const SCRIPT_ID = "kms-recaptcha-load-script";

export function initialise() {
    var recaptcha_key = window.kms.recaptcha_v3_public_key;
    // Setup an event handler for the forms which will load the recaptcha library.
    function load_recaptcha() {
        document.querySelectorAll('form[method="POST"]').forEach(function(recaptcha_form) {
            recaptcha_form.insertAdjacentHTML('beforeend','<div class="kms-loader recaptcha-kms-loader"></div>');
            recaptcha_form.removeEventListener('focusin', load_recaptcha);
        });
        if (!document.getElementById(SCRIPT_ID)) {
            let script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.type = 'text/javascript';
            script.src = 'https://www.google.com/recaptcha/api.js?render=' + recaptcha_key;
            script.addEventListener('load',()=>{
                grecaptcha.ready(function() {
                    //grecaptcha.execute('${app.config.get('recapatcha_v3_public_key')}', {action: '${slugify(data.CanonicalRelativeUrl(page))}'}).then(function(token) {});
                    document.querySelectorAll('form[method="POST"]').forEach(function(form) {
                        form.querySelectorAll('.recaptcha-kms-loader').forEach((element)=>element.parentNode.removeChild(element));
                        function addSubmitValue(e) {
                            form.submit_trigger = e.target;
                        }
                        form.querySelectorAll('[type="submit"]').forEach(function(submit_button) {
                            submit_button.addEventListener('click',addSubmitValue);
                        });
                        function handleFormSubmit(e) {
                            var form = e.target;
                            // Don't do anything if form doesn't validate.

                            e.preventDefault();
                            e.returnValue = false;
                            if (!form.submit_trigger || !form.submit_trigger.formnovalidate) {
                                if (typeof jQuery != 'undefined'){
                                    var $form = jQuery(form);
                                    if ($form.valid && !$form.valid()) return; //Jquery validate
                                }
                                if (form.reportValidity && !form.reportValidity()) return; //HTML5 validate
                            }
                            if (form.submit_trigger) { // Add value of submit element to form
                                form.insertAdjacentHTML('beforeend', '<input type="hidden" name="' + form.submit_trigger.name + '" value="' + form.submit_trigger.value + '"/>')
                            }
                            setSubmitButtonDisabled(form, true);
                            grecaptcha.execute(recaptcha_key, {action: 'submit'}).then(function(token) {
                                if (!form.querySelector("[name='g-recaptcha-response-v3']")) {
                                    form.insertAdjacentHTML('beforeend','<input type="hidden" name="g-recaptcha-response-v3" value="' + token + '"/>');
                                } else {
                                    form.querySelector("[name='g-recaptcha-response-v3']").value = token;
                                }
                                HTMLFormElement.prototype.submit.call(form);
                            });
                        }
                        form.addEventListener('submit', handleFormSubmit);
                        setSubmitButtonDisabled(form, false);
                    });
                });
            })
            document.body.appendChild(script);
            
        }
    }
    var recaptcha_forms = document.querySelectorAll('form[method="POST"]');
    // Skip forms with a data-no-recaptcha
    recaptcha_forms = Array.from(recaptcha_forms).filter(x => !('noRecaptcha' in x.dataset));
    recaptcha_forms.forEach(function(recaptcha_form) {
        recaptcha_form.addEventListener('focusin', load_recaptcha);
        recaptcha_form.insertAdjacentHTML('beforeend','<div class="recaptcha-notice">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</div>');
        setSubmitButtonDisabled(recaptcha_form, true);
        // If the form has zero focusable inputs, we just load the recaptcha script.
        if (recaptcha_form.querySelectorAll("select, input:not([type='hidden']):not([disabled])").length == 0) {
            load_recaptcha();
        }
        // If the form has all required fields populated we load recaptcha
        if ([...recaptcha_form.querySelectorAll("select[required], input[required]:not([type='hidden']):not([disabled])")].some((input)=> input.value && input.value !== '')) {
            load_recaptcha();
        }
    });
    
}

function setSubmitButtonDisabled(form, disabled) {    
    for (var submit_button of form.querySelectorAll('[type="submit"]')) {
        submit_button.disabled = disabled;
    }
}
